// Bridge module for passing React Router v5 location state between
// useHistoryMock (writer) and useLocationMock (reader).
//
// React Router v5's history.push(path, state) stores state on the history
// entry, accessible via useLocation().state. Next.js has no equivalent, so
// we use a Jotai atom to hold the state within React's lifecycle. This
// ensures proper reactivity — when state changes, consuming components
// re-render automatically.

import { atom } from 'jotai';

const locationStateAtom = atom(null);

export default locationStateAtom;
